import { RandomId, StringHelper } from "@swivl-mono/helpers";
import { NodeData_Array, NodeInterface, NodeType } from "@swivl-mono/types";
import { Dropdown, Input } from "@swivl-mono/ui";

import UserVariablesDropdown from "../../../../../Components/Dropdowns/UserVariablesDropdown/UserVariablesDropdown";
import { TagInput } from "../../../../../Components/TagInput/TagInput";
import VarsModel from "../../../../../Models/Variables/VarsModel.Model";
import TabNodeLayoutData, { TabNodePositionalData } from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";

const ArrayNode = {
  Type: NodeType.Array,
  Empty: function () {
    return {
      id: RandomId(6),
      type: ArrayNode.Type,
      action: "ADD",
      variableId: undefined,
      goto: undefined,
      values: "",
      count: 0,
    } as NodeData_Array;
  },

  PlumbData: function (node: NodeInterface) {
    const variable = node.variableId && node.variableId.length ? "#*" + node.variableId + "*#" : "Unset";
    let name = StringHelper.trimStringToLengthWithElipsis(VarsModel.replaceVariableNameInString(variable), 20);

    let tabs;
    if (node.action === "HAS") {
      tabs = [
        { title: "Has", id: "goto", source: "goto", target: node.goto },
        { title: "Missing", id: "hasNotGoto", source: "hasNotGoto", target: node.hasNotGoto },
      ];
    } else if (node.action === "COUNT") {
      tabs = [
        {
          title: `> ${VarsModel.replaceVariableNameInString(node.count)}`,
          id: "greaterThanGoto",
          source: "greaterThanGoto",
          target: node.greaterThanGoto,
        },
        {
          title: `< ${VarsModel.replaceVariableNameInString(node.count)}`,
          id: "lessThanGoto",
          source: "lessThanGoto",
          target: node.lessThanGoto,
        },
        {
          title: `== ${VarsModel.replaceVariableNameInString(node.count)}`,
          id: "equalToGoto",
          source: "equalToGoto",
          target: node.equalToGoto,
        },
        { title: "NOT SET", id: "notSetGoto", source: "notSetGoto", target: node.notSetGoto },
      ];
    } else {
      tabs = [{ id: "goto", source: "goto", target: node.goto }];
    }

    let label = "Array Variable Unset";
    if (variable !== "Unset") {
      if (node.action === "CLEAR") {
        label = "CLEAR ARRAY";
      } else if (node.action === "HAS") {
        label = "DOES ARRAY HAVE";
      } else if (node.action === "ADD") {
        label = "ADD TO ARRAY";
      } else if (node.action === "REMOVE") {
        label = "REMOVE FROM ARRAY";
      } else if (node.action === "COUNT") {
        label = "COUNT";
      }
    }
    const title = node.action === "CLEAR" ? "" : VarsModel.replaceVariableNameInString(node.values);

    return TabNodeLayoutData({
      node: node,
      label: label,
      body: name,
      title: node.action === "CLEAR" ? "" : VarsModel.replaceVariableNameInString(node.values),
      titleHeight: title?.length > 14 ? 45 : 20,

      baseWidth: 150,
      tabs: tabs,
    });
  },

  InspectorPanel: class IncrementInspectorPanel extends NodePanel {
    onActionChange = (event: any) => {
      let node = JSON.parse(JSON.stringify(this.props.node));
      node.action = event.target.value;

      if (node.action === "COUNT") {
        delete node.goto;

        node.greaterThanGoto = "";
        node.lessThanGoto = "";
        node.equalToGoto = "";
        node.notSetGoto = "";
      } else if (this.props.node.action === "COUNT") {
        node.goto = "";
        delete node.greaterThanGoto;
        delete node.lessThanGoto;
        delete node.equalToGoto;
        delete node.notSetGoto;
      }

      this.props.updateNode(node, this.props.node, true);
    };

    onCountChange = (event: any) => {
      let node = JSON.parse(JSON.stringify(this.props.node));
      node.count = event.target.value;
      this.props.updateNode(node, this.props.node, true);
    };

    render() {
      const options = [
        { value: "ADD", id: "action", label: "Add" },
        { value: "REMOVE", id: "action", label: "Remove" },
        { value: "CLEAR", id: "action", label: "Clear" },
        { value: "HAS", id: "action", label: "Has" },
        { value: "COUNT", id: "action", label: "Count" },
      ];

      const node = this.props.node as NodeData_Array;

      return (
        <div className="panel ArrayNodePanel">
          <InspectorNodeHeader title="Array" />
          <label>Action</label>

          <Dropdown options={options} value={this.props.node.action} onChange={this.onActionChange} name="action" />

          {(node.action === "HAS" || node.action === "ADD" || node.action === "REMOVE") && (
            <>
              <label>Array Variable</label>

              <UserVariablesDropdown onChange={this.onChange} skipUserId={true} name="variableId" value={node.variableId} skipBotVariables={true} />
              <div className="row">
                <label>Values</label>

                <TagInput value={this.props.node.values} onChange={this.onChange} name="values" />

                <small>Note: Comma seperate to enter multiple values.</small>
              </div>
            </>
          )}

          {node.action === "CLEAR" && (
            <>
              <label>Array Variable To Clear</label>

              <UserVariablesDropdown onChange={this.onChange} skipUserId={true} name="variableId" value={node.variableId} skipBotVariables={true} />
            </>
          )}

          {node.action === "COUNT" && (
            <>
              <label>Array Variable</label>

              <UserVariablesDropdown onChange={this.onChange} skipUserId={true} name="variableId" value={node.variableId} skipBotVariables={true} />
              <div className="row">
                <label>Value</label>

                <Input type={Input.Type.Integer} value={this.props.node.count} onChange={this.onCountChange} name="count" />

                <small>Note: Enter a number.</small>
              </div>
            </>
          )}

          <InspectorFooter deleteNode={this.deleteNode} node={this.props.node} />
        </div>
      );
    }
  },
};
export default ArrayNode;
